/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ActionClass12(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ActionClass12',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('rect', {"width":"12","height":"12","fill":"#0073E6","rx":"1"}),createElement('path', {"fill":"#FFF","fillOpacity":".9","d":"m6.748 5.114 2.978-3.31a.443.443 0 0 1 .6-.054c.184.142.232.4.11.6l-2.32 3.817a2.5 2.5 0 0 0-1.368-1.053m.06 1.2a1.7 1.7 0 0 0-1.325-.28c-.635.138-.96.68-1.377 1.104s-1.01.705-1.59.832a3.6 3.6 0 0 1-1.016.058c.235.507.6.965 1.087 1.314 1.484 1.07 3.55.747 4.607-.727a1.65 1.65 0 0 0-.385-2.3l-.01-.002z"})))
}
